import { translate } from '../helpers/translations';

export const autocompleteStickyCTA = (): string => {
  return `
  <button class="btn btn--secondary btn--sticky-cta">${translate('widget.sticky_cta')}</button>
  `;
};
